module.exports = __webpack_public_path__ + "static/media/student-summary-mission.8edfa4c7.png";